import React from 'react'

function Error() {
  return (
    <section className='section'>
      <p>Error!! Please check the URL</p>
    </section>  
  )
}

export default Error